export default __webpack_public_path__ + "static/media/crown.5f0e8826.png";